import React from 'react'
import type { BaseWeatherIconProps } from '../WeatherIcon'

const WeatherIconFreezingRain: React.FC<BaseWeatherIconProps> = ({
  className = '',
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 100 100"
      fill="none"
      className={className}
    >
      <path
        d="M52.4122 15.2921C51.4178 13.5694 48.9315 13.5693 47.9369 15.2918L9.35003 82.1244C8.35551 83.8468 9.59862 86 11.5876 86H88.7528C90.7417 86 91.9848 83.8471 90.9905 82.1246L52.4122 15.2921Z"
        fill="#F25470"
      />
      <path
        d="M48.7142 23.2698C49.2846 22.2631 50.7319 22.254 51.3149 23.2535L83.6845 78.7442C84.2678 79.7442 83.5465 81 82.3888 81H18.5745C17.4251 81 16.7028 79.7604 17.2694 78.7605L48.7142 23.2698Z"
        fill="white"
      />
      <path
        d="M60.8072 55.3026L59.3292 48.0693L46.5809 44.6421L41.6849 50.1571L40.1052 49.7414L37.9805 57.6952L40.3638 58.3418L40.1606 59.1086C39.8003 60.4204 40.5948 61.7783 41.9066 62.1386C43.2183 62.4989 44.5763 61.7044 44.9366 60.3926L45.1398 59.6167L53.0936 61.7414L52.8904 62.5266C52.5301 63.8384 53.3246 65.1963 54.6363 65.5566C55.9481 65.9169 57.3061 65.1224 57.6664 63.8107L57.8788 63.0162L60.2622 63.6629L62.3869 55.709L60.8072 55.3026ZM44.3823 55.1271C44.1791 55.8753 43.4216 56.328 42.6733 56.1525C41.925 55.9492 41.4724 55.1548 41.6479 54.4065C41.8511 53.6582 42.6456 53.2056 43.3939 53.4088C44.1421 53.6213 44.5948 54.3696 44.3823 55.1271ZM58.7102 58.97C58.507 59.7183 57.7125 60.1709 56.9643 59.9677C56.216 59.8014 55.7634 59.007 55.9666 58.2587C56.1698 57.5104 56.9643 57.0578 57.7125 57.261C58.4793 57.455 58.9227 58.2125 58.7102 58.97ZM43.4585 50.6375L47.1629 46.4897L57.925 49.3626L59.0243 54.813L43.4585 50.6375Z"
        fill="#222222"
      />
      <path
        d="M41.8882 65.926C41.7219 65.7597 41.6849 65.4456 41.7866 65.2054L42.4055 64.0045L40.3824 63.4595L39.939 64.3186C39.4217 65.344 39.6249 66.5819 40.5856 67.5057L45.0013 70.665C45.2785 70.8682 45.3431 71.247 45.1676 71.5241L41.1491 77.3532H43.6526L46.8397 72.6881C47.6711 71.4872 47.357 69.8428 46.193 68.9837L41.8882 65.926Z"
        fill="#222222"
      />
      <path
        d="M54.7014 69.2147C54.5351 69.0485 54.4612 68.7344 54.5998 68.4942L55.1448 67.3949L53.1217 66.8499L52.743 67.5981C52.2257 68.6235 52.4289 69.8614 53.3619 70.7852L57.8146 73.9445C58.0917 74.1478 58.1564 74.5265 57.9531 74.8037L56.2441 77.3441H58.7476L59.6714 75.9676C60.5028 74.7667 60.1887 73.1224 59.0247 72.2632L54.7014 69.2147Z"
        fill="#222222"
      />
    </svg>
  )
}

export default WeatherIconFreezingRain
